import React from "react";
import { useMutation } from "react-query";
import { getDeactivateById } from "../../../../actions/Utilities/CustomReport";

const useDeactivateCustomReport = () => {
  return useMutation(getDeactivateById);
};

export default useDeactivateCustomReport;
